import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingProvider3 = props => (
    <section id="outsourcing-provider-section3" className="my pt-5">
        <div className='white-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingProvider:section-3.title')}</h2>
            {[1, 2, 3, 4, 5].map(item => (
                <div key={item} className='mb-4'>
                    <h3 className='h6 fw-600 light-orange'>{props.t('services:outsourcingProvider:section-3.' + item + '.title')}</h3>
                    <p>
                        <Trans i18nKey={'services:outsourcingProvider:section-3.' + item + '.text'}
                            components={{
                                br: <br />,
                                outsourcingService: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing.path')} className="link" />,
                                outsourcingAdvantages: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_advantages.path')} className="link" />
                            }}
                        />
                    </p>
                </div>
            ))}
        </Container>
    </section>
);

export default OutsourcingProvider3;
